module.exports = __webpack_public_path__ + "static/img/1.1299bbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/juhua/R22/1.jpg
// module id = utic
// module chunks = 1